import { services } from "../../../../constants/services";
import { getByQuery } from "../../../../utils/api";
export interface IParamasGetEnvironment {
  sessionId?: string,
}
export const GetInquiryDetailsBySessionService = async (params: IParamasGetEnvironment) => {
  const response: any = await getByQuery<any>(`${services.analytics}/inquiry-details-by-session`,params);
  return response?.data;
};